<style src="./ChangeClient.scss" lang="scss"></style>
<template>
  <div class="main-container">
    <h2 class="title">Selecione para qual usuário deseja mudar</h2>
    <form class="form" v-on:submit.prevent="changeClient">
      <div class="form-group">
        <label>Selecione o cliente</label><br />
        <select class="form-select available" v-model="selectedClient">
          <option
            v-for="(client, index) in availableClients"
            :key="index"
            :value="client._id"
          >
            {{ client.fullName }}
          </option>
        </select>
      </div>

      <button
        class="btn btn-block btn-primary compose-mail"
        href="mail_compose.html"
      >
        <i class="fa fa-save"></i>
        Salvar
      </button>
    </form>
  </div>
</template>
<script>
export default {
  data: () => ({
    selectedClient: '',
    availableClients: [],
  }),

  mounted() {
    this.getClient();
    this.getAvailableClients();
  },
  methods: {
    getClient() {
      const client = this.$store.getters['DATA-ACCESS/client'];
      this.selectedClient = client._id;
    },
    getAvailableClients() {
      const availableClients = this.$store.getters[
        'DATA-ACCESS/availableClients'
      ];
      this.availableClients = availableClients.map(av => av.client);
    },
    async changeClient() {
      try {
        if (!this.selectedClient) {
          this.$toasted.error('Selecione um cliente');
          return;
        }
        await this.$store.dispatch('EMPLOYEE/ChangeClient', {
          clientId: this.selectedClient,
        });
        this.$toasted.success('Alterações salvas');
        this.$router.push({
          path: '/',
        });
      } catch (error) {
        this.$toasted.error('Não foi possível salvar o cliente selecionado.');
      }
    },
  },
};
</script>